import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { getProviderAdjustmentDecreaseItems } from "store/provider-dashboard/provider-dashboard-action"
import { useSearchParams } from "react-router-dom"
import ProviderAdjustmentDecreaseItemsList from "components/ProviderDashboard/ProviderItems/ProviderAdjustmentDecreaseItemsList"
import { providerDashboardAction } from "store/provider-dashboard/provider-dashboard-slice"

const ProviderAdjustmentDecrease = () => {
  const dispatch = useDispatch()

  const [searchParams] = useSearchParams()

  // get params from url parameter
  const getParams = {
    itemId: searchParams.get("itemId"),
    from: searchParams.get("from") !== "null" ? searchParams.get("from") : null,
    to: searchParams.get("to") !== "null" ? searchParams.get("to") : null,
    type: searchParams.get("type"),
  }

  const ProviderAdjustmentDecreaseItems = useSelector(
    state => state.providerDashboard.ProviderAdjustmentDecreaseItems
  )

  // get adjustment decrease items based params
  useEffect(() => {
    dispatch(getProviderAdjustmentDecreaseItems(getParams))

    return () => {
      dispatch(providerDashboardAction.resetProviderAdjustmentDecreaseItems())
    }
  }, [])

  return (
    // Provider Adjustment Decrease Item list components
    <ProviderAdjustmentDecreaseItemsList
      data={ProviderAdjustmentDecreaseItems?.data?.data}
      loading={ProviderAdjustmentDecreaseItems?.loading}
    />
  )
}

export default ProviderAdjustmentDecrease
